import { format } from "date-fns";

export function formatRocketchatTimestamp(time: Date | number | string) {
  const date = typeof time === "string" ? new Date(time) : time;
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
}
